import { Stack } from '@mui/joy';
import { ReactNode, useMemo } from 'react';

import { useGetDefaultVendors } from 'contacts/hooks';
import { Loader } from 'core/elements';
import { Direction, Size } from 'theme/enums';

import { VendorCostCard } from './VendorCostCard';

interface IProps {
  partNumber?: string;
  manufacturerId?: number;
  firstCard?: ReactNode;
  enabled?: boolean;
}

const loaderSx = { width: 'auto', margin: 0, alignSelf: 'center' };

export const PartCostCards = ({
  partNumber,
  manufacturerId,
  firstCard,
  enabled = true,
}: IProps) => {
  const queryEnabled = enabled && !!partNumber && !!manufacturerId;

  const requestPayload = useMemo(
    () => ({ filters: { partNumber, manufacturerId } }),
    [partNumber, manufacturerId]
  );

  const { records, isLoading } = useGetDefaultVendors(requestPayload, { enabled: queryEnabled });

  if (!firstCard && !records?.length && !isLoading) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} sx={{ flexWrap: 'wrap', gap: 2 }}>
      {firstCard}
      {records?.map((vendor) => (
        <VendorCostCard
          key={vendor.id}
          groupName={vendor.groupName}
          vendorName={vendor.name}
          standardCost={vendor.pricingData?.standardCost}
          purchaseCost={vendor.pricingData?.purchaseCost}
          uom={vendor.uom}
          costState={vendor.costState}
        />
      ))}
      {isLoading && <Loader size={Size.SM} style={loaderSx} />}
    </Stack>
  );
};
